/*
    Пайп который трансформирует строку разбивая ее на требуемые части,
    например пайп на вход принял 60 симвоов, он будет разбивать строку по 60
    символов и переносить каждую часть на новую строку, но при этом не
    разбивает слова, просто ищет пробел двигаясь назад по строке, а
    оставшуюся часть сново перебирает и делит
*/

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'lineBreak'
})
export class LineBreakPipe implements PipeTransform {
    response: string;

    transform(value: string, maxCharacterLength: number): string {
        this.response = '';
        if (value.length < maxCharacterLength) {
            return value;
        }
        return this.createResponse(value, maxCharacterLength);
    }

    createResponse(value, maxCharacterLength): string {
        // делит строку на части
        if (value.length > maxCharacterLength) {
            const maxValueStr = value.slice(0, maxCharacterLength - 1);
            const findSpace = this.findSpace(maxValueStr, maxCharacterLength);
            const firstChart = value.slice(0, findSpace);
            const lastChart = value.slice(findSpace);

            this.response += `${firstChart}<br>`;

            if (lastChart.length > maxCharacterLength) {
                return this.createResponse(lastChart, maxCharacterLength);
            }
            return (this.response += lastChart);
        }
        return this.response;
    }

    findSpace(instance: string, recNumber: number): number {
        // ищет пробел пробегаясь по переданой строке назад чтобы
        // не разбивать слова, возвращает индекс пробела
        if (instance[recNumber] === ' ' || recNumber === 0) {
            return recNumber;
        }
        return this.findSpace(instance, recNumber - 1);
    }
}
